import {
    SkyNetTableConfig,
} from 'app/shared-components/SkyNetTable/types/skyNetTable.types'
import {
    OrderStatuses,
    OrderTypes,
    ProductType,
} from 'app/enums/label.enums'
import {
    FilterType,
} from 'app/enums/common.enums'

import {
    TruckingCapacityInbound,
} from './relatedOrders.types'

const config: SkyNetTableConfig<keyof TruckingCapacityInbound> = {
    name: 'RelatedOrders-InboundOrders',
    fields: [
        {
            name: 'orderNumber',
            width: '160px',
            labelKey: 'ORDER',
            componentName: 'OrderTableLink',
        },
        {
            name: 'orderStatus',
            componentName: 'EnumValue',
            allowedValuesEnum: OrderStatuses,
            labelKey: 'ORDER_STATUS',
        },
        {
            name: 'orderType',
            componentName: 'EnumValue',
            allowedValuesEnum: OrderTypes,
            labelKey: 'ORDER_TYPE',
            filterField: 'orderType',
            filterType: FilterType.Array,
        },
        {
            name: 'from',
            labelKey: 'FROM',
        },

        {
            name: 'originLocationLocationName',
            labelKey: 'ORIGIN_LOCATION',
        },
        {
            name: 'estimatedDelivery',
            sorting: false,
            labelKey: 'ESTIMATED_DELIVERY',
        },
        {
            name: 'requiredContainers',
            componentName: 'RequiredContainersList',
            allowedValuesEnum: ProductType,
            sorting: false,
            labelKey: 'REQUIRED_CONTAINERS',
            filterField: 'requiredContainers',
            filterType: FilterType.Array,
        },
    ],
}

export default config
